import TYPES from './types';
import { get, put, post, deleteRequest } from 'utils/api';
import { successHandler } from 'common/utils/notifications';

export const getCrewRank = params => async dispatch => {
  try {
    dispatch({ type: TYPES.GET_CREW_RANK.START, payload: { params } });

    const response = await get('/enums/crew-ranks', params);

    dispatch({ type: TYPES.GET_CREW_RANK.SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: TYPES.GET_CREW_RANK.ERROR, payload: error });
  }
};

export const createCrewRank = params => async dispatch => {
  try {
    dispatch({ type: TYPES.CREATE_CREW_RANK.START, payload: { params } });

    const response = await post('/enums/crew-ranks', params);

    dispatch({ type: TYPES.CREATE_CREW_RANK.SUCCESS, payload: response.data });
    dispatch(successHandler({ title: 'Success!', message: 'Created successfully' }));
  } catch (error) {
    dispatch({ type: TYPES.CREATE_CREW_RANK.ERROR, payload: error });
    throw error;
  }
};

export const updateCrewRank = params => async dispatch => {
  try {
    dispatch({ type: TYPES.UPDATE_CREW_RANK.START, payload: { params } });
    const { id, ...rest } = params;

    const response = await put(`/enums/crew-ranks/${id}`, { ...rest });

    dispatch({ type: TYPES.UPDATE_CREW_RANK.SUCCESS, payload: response.data });
    dispatch(successHandler({ title: 'Success!', message: 'Updated successfully' }));
  } catch (error) {
    dispatch({ type: TYPES.UPDATE_CREW_RANK.ERROR, payload: error });
  }
};

export const reorderCrewRank = params => async dispatch => {
  try {
    dispatch({ type: TYPES.REORDER_CREW_RANK.START, payload: { ...params } });
    const { itemToUpdate, newIndex } = params;
    const response = await put(`/enums/crew-ranks/${itemToUpdate.id}`, { sort_index: newIndex });

    dispatch({ type: TYPES.REORDER_CREW_RANK.SUCCESS, payload: response.data });
    dispatch(successHandler({ title: 'Success!', message: 'Updated successfully' }));
  } catch (error) {
    dispatch({ type: TYPES.REORDER_CREW_RANK.ERROR, payload: error });
  }
};

export const deleteCrewRank = params => async dispatch => {
  try {
    dispatch({ type: TYPES.DELETE_CREW_RANK.START, payload: { params } });
    const { id, ...rest } = params;

    const response = await deleteRequest(`/enums/crew-ranks/${id}`, { ...rest });

    dispatch({ type: TYPES.DELETE_CREW_RANK.SUCCESS, payload: response.data });
    dispatch(successHandler({ title: 'Success!', message: 'Deleted successfully' }));
  } catch (error) {
    dispatch({ type: TYPES.DELETE_CREW_RANK.ERROR, payload: error });
  }
};
